import { createFileRoute } from '@tanstack/react-router'
import { Chefs } from '@/features/chefs'

export const Route = createFileRoute('/_authenticated/chefs/')({
  component: Chefs,
})

